import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyUrl: string;
    viewInProject: string;
    viewInTrash: string;
    download: string;
    import: string;
    openInNewTab: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label to copy asset URL */
            copyUrl: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetContextMenuContent.copyUrl?c=dubbsl04cxng", defaultMessage: "Copy URL" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to view asset in its project */
            viewInProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetContextMenuContent.viewInProject?c=2le9k4ftq4ndt", defaultMessage: "View in Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to view asset in trash/recently deleted */
            viewInTrash: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetContextMenuContent.viewInTrash?c=1cogtekybqtzx", defaultMessage: "Go to Recently Deleted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to download asset */
            download: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetContextMenuContent.download?c=82r1papihj9v", defaultMessage: "Download" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to import asset (used in Premiere client) */
            import: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetContextMenuContent.import?c=1738ymkzqvsth", defaultMessage: "Import" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to open asset in a new tab */
            openInNewTab: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetContextMenuContent.openInNewTab?c=3gbxo9enryfdt", defaultMessage: "Open in New Tab" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
